module.exports = __webpack_public_path__ + "img/8.c0cb6f48.svg";